
export function getSessionDeactivatedMessage(errorOrResponse: any): string | undefined {
  const errors =
    errorOrResponse?.response?.data?.errors ??
    errorOrResponse?.data?.errors ??
    errorOrResponse?.errors;
  const msgs = errors?.NoValidSessionIsDeactivatedException;
  if (Array.isArray(msgs) && msgs.length > 0) return msgs[0] as string;
  return undefined;
}

export function isSessionDeactivatedError(errorOrResponse: any): boolean {
  return getSessionDeactivatedMessage(errorOrResponse) !== undefined;
}
